import JSDos from "./JSDos";

export default JSDos;
